
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#474747","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"15"}},[_c('path',{attrs:{"d":"M361.602 403.136c-27.26.431-134.082 2.072-140.899 1.462-7.95-.719-90.636-21.343-90.636-21.343L18.782 340.499m392.168-5.859l57.899-21.957c10.164-3.778 21.5 1.592 24.949 11.977 3.286 9.893-2.209 20.585-11.98 24.219L434.02 371.77M18.782 220.343l91.582 58.652a29.104 29.104 0 0026.455 2.542c24.878-9.899 76.45-29.478 94.858-29.343a23.01 23.01 0 017.908.376l94.001 21.233c12.178 2.751 20.411 14.564 18.094 26.832-2.432 12.879-15.025 21.068-27.702 18.207l-34.896-7.882-38.511-8.82c-7.13-1.628-14.228 2.822-15.861 9.949-1.632 7.127 2.822 14.228 9.949 15.861l111.797 24.58m131.76-270.659l-65.717-3.186v30.769h-76V67.203c0-20.154 15.29-37.02 35.347-38.992l106.37-10.34M385.999 78.454h-36M422.216 138.871v160M391.216 200.871v40M391.216 173.871v4M346.216 138.871v101.658M31.456 150.529c1.581.791 63.812 54.728 89.789 77.268a27.068 27.068 0 0025.454 5.501l76.124-22.611a44.996 44.996 0 0122.015-.913c22.113 4.619 68.618 14.755 68.618 14.755M417.456 489.403v6.126M384.199 344.785l9.916 4.993a42.415 42.415 0 0123.341 37.885v76.346M367.456 459.67v35.859M356.456 352.529h0a29.993 29.993 0 0111 23.213v58.123M449.471 264.041l19-35M464.471 282.041l19-6M250.456 429.529v64M304.456 485.529v8M304.456 429.529v32"}})])])
          )
        }
      }
    